import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import theme from '../theme.config';
export var container = theme.css({
  fontFamily: '$defaultFont',
  backgroundColor: '$card-bg',
  boxShadow: '$card',
  borderStyle: '$card-border',
  borderWidth: '$card-border',
  borderColor: '$card-border',
  borderRadius: '$card-rounded',
  '--space-card-p': '$space$card-md-p',
  variants: {
    accent: {
      info: {
        borderLeftWidth: '$card-accent',
        borderLeftStyle: 'solid',
        borderLeftColor: '$card-accent'
      }
    },
    size: {
      small: {
        '--space-card-p': '$space$card-sm-p'
      },
      medium: {}
    },
    isQuiet: {
      "true": {
        '--shadows-card': '$shadows$card-quiet'
      }
    },
    clickable: {
      "true": {
        position: 'relative',
        '&:before': {
          content: "' '",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          overflow: 'hidden',
          position: 'absolute',
          transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          borderRadius: 'inherit',
          pointerEvents: 'none',
          backgroundColor: '$transparent'
        },
        '&:hover': {
          boxShadow: '$card-hover',
          cursor: 'pointer',
          '&:before': {
            backgroundColor: '$card-mask'
          }
        },
        '&:active:before': {
          backgroundColor: '$card-mask'
        },
        '&:focus-within': {
          outline: '$outlines$focusOutline',
          outlineOffset: '$outlines$focusOutlineOffset'
        },
        '& a:focus': {
          textDecoration: 'underline'
        },
        '&:focus-within a:focus': {
          textDecoration: 'none',
          outline: 'none'
        }
      }
    }
  }
});
export var msGrid = function msGrid(maxWidth) {
  return theme.css({
    display: '-ms-grid',
    '-ms-grid-rows': 'auto auto 1fr auto',
    variants: {
      imagePosition: {
        top: {
          '-ms-grid-columns': '0px minmax(0px, 1fr) min-content 0px'
        },
        right: {
          '-ms-grid-columns': "0px minmax(0px, 1fr) min-content ".concat(maxWidth || '50%', ")")
        },
        left: {
          '-ms-grid-columns': "".concat(maxWidth || '50%', " minmax(0px, 1fr) min-content 0px")
        }
      }
    }
  });
};
export var grid = theme.css({
  display: 'grid',
  gridTemplateRows: 'auto auto auto 1fr auto',
  gridTemplateAreas: "\n    '. top top .'\n    'left header close right'\n    'left content content right'\n    'left sections sections right'\n    'left footer footer right'\n  ",
  width: '$full',
  variants: {
    imagePosition: {
      top: {
        gridTemplateColumns: "\n          [left] 0\n          [header] minmax(0, 1fr)\n          [close] min-content\n          [right] 0\n        "
      },
      right: {
        gridTemplateColumns: "\n          [left] 0\n          [header] minmax(0, 1fr)\n          [close] min-content\n          [right] var(--sizes-card-preview-max-w, 50%)\n        "
      },
      left: {
        gridTemplateColumns: "\n          [left] var(--sizes-card-preview-max-w, 50%)\n          [header] minmax(0, 1fr)\n          [close] min-content\n          [right] 0\n        "
      }
    }
  }
});
export var preview = theme.css({
  margin: 0,
  overflow: 'hidden',
  '& > img': {
    width: '$full',
    verticalAlign: 'top'
  },
  variants: {
    position: {
      left: _objectSpread({
        gridArea: 'left',
        borderTopLeftRadius: 'var(--radii-card-rounded)',
        borderBottomLeftRadius: 'var(--radii-card-rounded)',
        '& > img': {
          height: '$full'
        }
      }, {
        '-ms-grid-column': '1',
        '-ms-grid-row-span': '3',
        '-ms-grid-row': '1'
      }),
      right: _objectSpread({
        gridArea: 'right',
        borderTopRightRadius: 'var(--radii-card-rounded)',
        borderBottomRightRadius: 'var(--radii-card-rounded)',
        '& > img': {
          height: '$full'
        }
      }, {
        '-ms-grid-column': '4',
        '-ms-grid-row-span': '3',
        '-ms-grid-row': '1'
      }),
      top: _objectSpread({
        gridArea: 'top',
        borderTopLeftRadius: 'var(--radii-card-rounded)',
        borderTopRightRadius: 'var(--radii-card-rounded)'
      }, {
        '-ms-grid-column': '1',
        '-ms-grid-column-span': '4',
        '-ms-grid-row': '1'
      })
    }
  }
});
export var header = theme.css({
  '-ms-grid-column': '2',
  '-ms-grid-row': '2',
  gridArea: 'header',
  padding: '$card-p $card-p 0'
});
export var content = theme.css({
  '-ms-grid-column': '2',
  '-ms-grid-row': '3',
  '-ms-grid-column-span': '2',
  gridArea: 'content',
  padding: '$card-p'
});
export var sections = theme.css({
  '-ms-grid-column': '2',
  '-ms-grid-row': '3',
  '-ms-grid-column-span': '2',
  gridArea: 'sections'
});
export var footer = theme.css({
  '-ms-grid-column': '2',
  '-ms-grid-row': '4',
  '-ms-grid-column-span': '2',
  gridArea: 'footer',
  padding: '$150 $card-p',
  textAlign: 'center',
  borderTop: '1px solid $card-border',
  borderRadius: '0 0 var(--radii-card-rounded) var(--radii-card-rounded)',
  backgroundColor: '$card-footer-bg',
  overflow: 'hidden'
});
export var orientation = theme.css({
  variants: {
    layout: {
      vertical: {
        '&& > *:not(style) ~ *': {
          borderTop: '1px solid $card-border'
        }
      },
      horizontal: {
        display: 'flex',
        '& > *': {
          flexBasis: 0,
          flexGrow: 1
        }
      }
    }
  }
});
export var transparentBackground = theme.css({
  backgroundColor: 'inherit'
});